// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"306":"learner-dashboard-main","569":"instructor-dashboard-main"}[chunkId] || chunkId) + "." + {"306":"a2f215940f62166fca1d","569":"bfbf2de53b4bd45ca030","710":"69cae1bbd13d664c6892"}[chunkId] + ".js";
};